var Shopify = Shopify || {};
const product = JSON.parse(document.querySelector('[data-product-id]').textContent);
const amount_with_comma_separator = '{{amount_with_comma_separator}}';
const variants = document.querySelectorAll('[data-variant]');
const crossselling = document.querySelectorAll('.crossselling-product');
const addToCartForm = document.querySelector('form[id="add-to-cart"]');
const stocks = document.querySelectorAll('input[name="variant-stock"]');
const imageWrapper = document.querySelectorAll('.product-swiper-main .swiper-wrapper .swiper-slide');
const addToCartError = document.querySelector('.add-to-cart-error');
var optionsSize = parseInt(document.querySelector('[data-options-size]').getAttribute('data-options-size'));
const stocksMap = {};
const stocksPolicyMap = {};
var currentOptions = {};

const popups = document.querySelectorAll('[data-pop-up]');

stocks.forEach((stock) => {
  const variantId = stock.value;
  const stockValue = parseInt(stock.getAttribute('data-stock'));
  const stockPolicyValue = stock.getAttribute('data-stock-policy');
  stocksMap[variantId] = stockValue;
  stocksPolicyMap[variantId] = stockPolicyValue;
});

// Add to cart
if (addToCartForm) {
  addToCartForm.addEventListener('submit', function (event) {
    event.preventDefault();
    const formData = new FormData(addToCartForm);
    const productId = formData.get('id');
    const productQty = formData.get('quantity');

    const items = [
      {
        id: productId,
        quantity: parseInt(productQty, 10),
      },
    ];

    crossselling.forEach(function (product) {
      const checkbox = product.querySelector('input[type="checkbox"]');
      if (checkbox && checkbox.checked) {
        const variantId = checkbox.getAttribute('data-variant-id');
        const crossellingQty = 1;
        items.push({
          id: variantId,
          quantity: parseInt(crossellingQty, 10),
        });
      }
    });

    if (productId != 0) {
      if (!addToCartError.classList.contains('hidden')) {
        addToCartError.classList.add('hidden');
      }
      if (items) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items: items }),
        })
          .then((response) => response.json())
          .then((data) => {
            window.location.href = `?add=${productId}`;
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      }
    } else {
      if (addToCartError.classList.contains('hidden')) {
        addToCartError.classList.remove('hidden');
      }
    }
  });
}

// Variants
if (variants) {
  // First init of the variants
  //initializeVariants();

  // Get the on click or on change state of the variant
  variants.forEach((variant) => {
    ['change'].forEach((event) => {
      variant.addEventListener(event, () => handleVariantChange(variant));
    });
  });
}

// Crossselling
if (crossselling) {
  crossselling.forEach(function (product) {
    handleCrosssellingChange(product);
  });
}

// Popups
if (popups) {
  popups.forEach(function (popup) {
    ['click'].forEach((event) => {
      popup.addEventListener(event, () => changePopup(popup));
    });
  });
}

function initializeVariants() {
  const optionNames = ['option1', 'option2', 'option3'];

  optionNames.forEach((optionName) => {
    var option = document.querySelector(`[name="${optionName}"]`);
    if (option) {
      if (option.tagName == 'SELECT') {
        var optionValue = option.options[1].getAttribute('data-value');
        option.options[1].selected = true;
        currentOptions[optionName] = optionValue;
      }
    }
  });

  if (currentOptions) {
    updateCurrentOptions(currentOptions);
  }
}

function handleVariantChange(variant) {
  const optionName = variant.getAttribute('data-name');

  if (variant.tagName == 'SELECT') {
    const selectedOption = variant.options[variant.selectedIndex];
    var optionValue = selectedOption.getAttribute('data-value');
  }

  if (optionValue !== null) {
    currentOptions[optionName] = optionValue;

    if (currentOptions) {
      updateCurrentOptions(currentOptions, optionName);
    }
  }
}

function handleCrosssellingChange(product) {
  const productPriceElement = product.querySelector('[data-product-price]');
  const checkbox = product.querySelector('input[type="checkbox"]');
  const basePrice = parseFloat(productPriceElement.getAttribute('data-product-price')) / 100;

  var quantity = 1;
  var totalPrice = basePrice;

  function updateQuantityAndPrice() {
    totalPrice = basePrice * quantity;
    productPriceElement.innerHTML = `${totalPrice.toFixed(2).replace('.', ',')}`;
    if (checkbox.checked) {
      updatePriceWithCrossselling();
    }
  }

  updateQuantityAndPrice();

  checkbox?.addEventListener('change', () => {
    updatePriceWithCrossselling();
  });
}

function updateCurrentOptions(currentOptions, optionName) {
  var option1 = currentOptions['option1'] || 'Default Title';
  var option2 = currentOptions['option2'] || '';
  var option3 = currentOptions['option3'] || '';

  if (optionName == 'option1') {
    option2 = '';
    option3 = '';
  }

  if (optionName == 'option2') {
    option3 = '';
  }

  var option1 = option1.replace(/@/g, '"');
  var option2 = option2.replace(/@/g, '"');
  var option3 = option3.replace(/@/g, '"');

  if (option1 && option1.trim() !== '') optionsSize = 1;
  if (option2 && option2.trim() !== '') optionsSize = 2;
  if (option3 && option3.trim() !== '') optionsSize = 3;

  switch (optionsSize) {
    case 3:
      var currentOption = product.variants.filter(
        (variant) => variant.option1 === option1 && variant.option2 === option2 && variant.option3 == option3
      );
      break;
    case 2:
      var currentOption = product.variants.filter(
        (variant) => variant.option1 === option1 && variant.option2 === option2
      );
      break;
    case 1:
      var currentOption = product.variants.filter((variant) => variant.option1 === option1);
      break;
  }

  if (currentOption[0] != undefined) {
    updateSpecifications(currentOption[0]);

    updateVariants(currentOption, optionName);

    if (currentOption.length == 1) {
      var id = currentOption[0].id;
      var price = currentOption[0].price;
      var compare_at_price = currentOption[0].compare_at_price;
      var stock = stocksMap[id] || 0;
      var stock_policy = stocksPolicyMap[id];

      // Hide the error message for the variants
      if (!addToCartError?.classList.contains('hidden')) {
        addToCartError?.classList.add('hidden');
      }

      updateExtraOptions(id);
      updatePriceWithStock(price, compare_at_price, stock, id, stock_policy);
    }
  }
}

function updateSpecifications(variant) {
  var variantId = variant.id;
  if (variantId !== null) {
    var url = document.querySelector('[data-product-url]').getAttribute('data-product-url');
    var final_url = url + '?variant=' + variantId;

    fetch(final_url)
      .then((response) => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then((html) => {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var specifications = doc.querySelector('#variant-specs');
        if (specifications) {
          document.querySelector('#variant-specs').innerHTML = specifications.innerHTML;
        }
      })
      .catch((error) => {
        console.error('Failed to fetch HTML:', error);
      });
  }
}

function updateExtraOptions(variantId) {
  var productCrossselling = document.querySelector('.product-crossselling');
  var variantCrossselling = document.querySelectorAll('.variant-crossselling');

  if (productCrossselling?.classList.contains('flex')) {
    productCrossselling.classList.remove('flex');
    productCrossselling.classList.add('hidden');
  }

  variantCrossselling?.forEach((crossselling) => {
    var crosssellingId = crossselling.getAttribute('data-crossselling-variant');
    if (crosssellingId == variantId) {
      var extraOptions = crossselling.querySelector('ul');
      if (extraOptions && extraOptions.querySelectorAll('li').length > 0) {
        if (crossselling.classList.contains('hidden')) {
          crossselling.classList.remove('hidden');
          crossselling.classList.add('flex');
        }
      }
    } else {
      if (crossselling.classList.contains('flex')) {
        crossselling.classList.remove('flex');
        crossselling.classList.add('hidden');
      }
    }
  });
}

function updateVariants(currentOption, optionName) {
  // Hide all the extra options
  var productCrossselling = document.querySelector('.product-crossselling');
  var variantCrossselling = document.querySelectorAll('.variant-crossselling');

  if (productCrossselling?.classList.contains('flex')) {
    productCrossselling.classList.remove('flex');
    productCrossselling.classList.add('hidden');
  }

  variantCrossselling?.forEach((crossselling) => {
    if (crossselling.classList.contains('flex')) {
      crossselling.classList.remove('flex');
      crossselling.classList.add('hidden');
    }
  });

  var selectOption2 = document.getElementById('option2');
  var selectOption3 = document.getElementById('option3');

  if (optionName == 'option1') {
    if (selectOption2 !== null) {
      selectOption2.innerHTML = '';
      var selectOptionDefault = document.createElement('option');
      selectOptionDefault.text = 'Maak een keuze';
      selectOption2.appendChild(selectOptionDefault);
    }

    if (selectOption3 !== null) {
      selectOption3.innerHTML = '';
      var selectOptionDefault = document.createElement('option');
      selectOptionDefault.text = 'Maak een keuze';
      selectOption3.appendChild(selectOptionDefault);
    }
  }

  if (optionName == 'option2') {
    if (selectOption3 !== null) {
      selectOption3.innerHTML = '';
      var selectOptionDefault = document.createElement('option');
      selectOptionDefault.text = 'Maak een keuze';
      selectOption3.appendChild(selectOptionDefault);
    }
  }

  currentOption.forEach((variant) => {
    if (optionName == 'option1') {
      if (selectOption2 !== null) {
        if (variant.option2 !== '') {
          const exists = Array.from(selectOption2.options).some((opt) => opt.textContent === variant.option2);

          if (!exists) {
            const option = document.createElement('option');
            option.value = variant.id;
            option.textContent = variant.option2;

            // Set data attributes
            option.setAttribute('data-name', 'option2');
            option.setAttribute('data-value', variant.option2);
            option.setAttribute('data-id', variant.id);
            option.setAttribute('data-stock', stocksMap[variant.id]);
            option.setAttribute('data-price', variant.price);

            selectOption2.appendChild(option);
          }
        }
      }

      if (selectOption3 !== null) {
        if (variant.option3 !== '') {
          var option = document.createElement('option');
          option.value = variant.id;
          option.textContent = variant.option3;

          // Set data attributes
          option.setAttribute('data-name', 'option3');
          option.setAttribute('data-value', variant.option3);
          option.setAttribute('data-id', variant.id);
          option.setAttribute('data-stock', stocksMap[variant.id]);
          option.setAttribute('data-price', variant.price);

          selectOption3.appendChild(option);
        }
      }
    }

    if (optionName == 'option2') {
      if (selectOption3 !== null) {
        if (variant.option3 !== '') {
          var option = document.createElement('option');
          option.value = variant.id;
          option.textContent = variant.option3;

          // Set data attributes
          option.setAttribute('data-name', 'option3');
          option.setAttribute('data-value', variant.option3);
          option.setAttribute('data-id', variant.id);
          option.setAttribute('data-stock', stocksMap[variant.id]);
          option.setAttribute('data-price', variant.price);

          selectOption3.appendChild(option);
        }
      }
    }
  });
}

function updatePriceWithStock(price, compare_at_price, stock, id, stock_policy) {
  const currentPrice = document.querySelector('.current-price');
  const currentComparePrice = document.querySelector('.compare-at-price');
  const quantity = 1;

  const discountFixedAmount = document
    .querySelector('[data-metafield-discount-fixed-amount]')
    .getAttribute('data-metafield-discount-fixed-amount');
  const discountPercentage = document
    .querySelector('[data-metafield-discount-percentage]')
    .getAttribute('data-metafield-discount-percentage');

  var totalPrice = price * quantity;
  var totalComparePrice = compare_at_price * quantity;

  if (discountFixedAmount > 0) {
    var totalPrice = (price - discountFixedAmount) * quantity;
    var totalComparePrice = price * quantity;
  }

  if (discountPercentage > 0) {
    var totalPrice = (price - price * (discountPercentage / 100)) * quantity;
    var totalComparePrice = price * quantity;
  }

  if (crossselling) {
    crossselling.forEach(function (product) {
      const checkbox = product.querySelector('input[type="checkbox"]');
      const crosssellingQuantityInput = 1;

      if (checkbox && checkbox.checked && crosssellingQuantityInput) {
        const crosssellingQuantity = parseInt(crosssellingQuantityInput.value || 1);
        const crosssellingPrice = parseFloat(
          product.querySelector('[data-product-price]').getAttribute('data-product-price')
        );
        totalPrice += crosssellingPrice * crosssellingQuantity;
        totalComparePrice += crosssellingPrice * crosssellingQuantity;
      }
    });
  }

  const prettyPrice = Shopify.formatMoney(totalPrice, amount_with_comma_separator);
  const prettyComparePrice = Shopify.formatMoney(totalComparePrice, amount_with_comma_separator);

  if (currentPrice) {
    currentPrice.setAttribute('data-solo-price', price);
    currentPrice.setAttribute('data-price', price);
    currentPrice.setAttribute('data-stock', stock);
    currentPrice.innerHTML = `€${prettyPrice}`;
  }

  if (totalComparePrice > 0) {
    if (currentComparePrice) {
      currentComparePrice.setAttribute('data-compare-price', compare_at_price);
      currentComparePrice.innerHTML = `€${prettyComparePrice}`;
    }
  } else {
    if (currentComparePrice !== null) {
      currentComparePrice.innerHTML = '';
    }
  }

  const addToCartBtn = document.querySelector('[data-add-to-cart-button]');
  const outOfStockBtn = document.querySelector('[data-out-of-stock-button]');
  const onStockText = document.querySelector('[data-product-on-stock]');
  const outStockText = document.querySelector('[data-product-out-stock]');

  const toggleClass = (element, removeClass, addClass) => {
    if (element) {
      element.classList.remove(removeClass);
      element.classList.add(addClass);
    }
  };

  // Aangepast 06-08-2025: Winkelwagenknop moet ten alle tijden worden getoond.
  // Aangepast 17-10-2025: Winkelwagenknop aangepast. Als een product niet op voorraad is dan blijft de winkelwagenknop staan.

  if (stock <= 0 || stock < quantity) {
    if (stock_policy == 'deny') {
      toggleClass(addToCartBtn, 'btn', 'hidden');
      toggleClass(outOfStockBtn, 'hidden', 'btn');
    }
    if (stock_policy == 'continue') {
      if (stock <= 0) {
        toggleClass(onStockText, 'flex', 'hidden');
        toggleClass(outStockText, 'hidden', 'flex');
      }
    }
  } else {
    toggleClass(onStockText, 'hidden', 'flex');
    toggleClass(outStockText, 'flex', 'hidden');
  }

  var variantId = document.querySelector(`input[name="id"]`);
  variantId.value = id;

  var quantityField = document.querySelector(`input[name="quantity"]`);
  quantityField.value = quantity;

  var selectedImage = document.querySelector(`input[data-id-image="${id}"]`).getAttribute('data-image');
  selectedImage &&
    imageWrapper.forEach((image) => {
      if (image.classList.contains('swiper-slide-active')) {
        let activeImageWrapper = image.querySelector('img:not(.btn-video-img)');
        let activeImageAnchor = image.querySelector('a');
        activeImageAnchor.href = selectedImage;
        activeImageWrapper.src = selectedImage;
      }
    });
}

function updatePriceWithCrossselling() {
  const currentPrice = document.querySelector('.current-price');
  const currentComparePrice = document.querySelector('.compare-at-price');
  const quantity = 1;
  const price = currentPrice.getAttribute('data-price');
  let compare_at_price = currentComparePrice?.getAttribute('data-compare-price') || 'null';

  if (compare_at_price === 'null') {
    compare_at_price = parseFloat(currentPrice.getAttribute('data-price'));
  }

  const discountFixedAmount = document
    .querySelector('[data-metafield-discount-fixed-amount]')
    .getAttribute('data-metafield-discount-fixed-amount');
  const discountPercentage = document
    .querySelector('[data-metafield-discount-percentage]')
    .getAttribute('data-metafield-discount-percentage');

  var totalPrice = price * quantity;
  var totalComparePrice = compare_at_price * quantity;

  if (discountFixedAmount > 0) {
    var totalPrice = (price - discountFixedAmount) * quantity;
  }

  if (discountPercentage > 0) {
    var totalPrice = (price - price * (discountPercentage / 100)) * quantity;
  }

  if (crossselling) {
    crossselling.forEach(function (product) {
      const checkbox = product.querySelector('input[type="checkbox"]');
      const crosssellingQuantityInput = 1;

      if (checkbox && checkbox.checked && crosssellingQuantityInput) {
        const crosssellingQuantity = 1;
        const crosssellingPrice = parseFloat(
          product.querySelector('[data-product-price]').getAttribute('data-product-price')
        );
        totalPrice += crosssellingPrice * crosssellingQuantity;
        totalComparePrice += crosssellingPrice * crosssellingQuantity;
      }
    });
  }

  const prettyPrice = Shopify.formatMoney(totalPrice, amount_with_comma_separator);
  const prettyComparePrice = Shopify.formatMoney(totalComparePrice, amount_with_comma_separator);

  if (currentPrice) {
    currentPrice.innerHTML = `€${prettyPrice}`;
  }

  if (currentComparePrice) {
    currentComparePrice.innerHTML = `€${prettyComparePrice}`;
  }
}

function changePopup(popup) {
  const wrapper = document.querySelector('.pop-up');
  const popUpTinyTitle = wrapper.querySelector('.tiny-title');
  const popUpTitle = wrapper.querySelector('.title');
  const popUpDesc = wrapper.querySelector('.desc');

  let tinyTitle = popup.getAttribute('data-option');
  let title = popup.getAttribute('data-title');
  let desc = popup.getAttribute('data-description');

  popUpTinyTitle.textContent = '';
  popUpTitle.textContent = '';
  popUpDesc.textContent = '';

  if (tinyTitle !== undefined) {
    popUpTinyTitle.textContent = tinyTitle;
  }
  if (title !== undefined) {
    popUpTitle.textContent = title;
  }
  if (desc !== undefined) {
    popUpDesc.textContent = desc;
  }
}
